module.exports = __webpack_public_path__ + "static/img/企业logo7.0181b312.jpeg";